// extracted by mini-css-extract-plugin
module.exports = {"liveBtn":"DaoLiveButton_liveBtn__d5Vj7","viewBtn":"DaoLiveButton_viewBtn__x7i2b"};